import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import ShLabel from "../../../../components/theme/label/ShLabel";
import { tokens } from "../../../../theme";
// import { getAllStock } from "../../../../api/warehouse/stock";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from '../../../../components/theme/sidepanel2/SidepanelLoader';
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import { useGetBatchesQuery } from "../../../../newapi/batch/batchSlice";
import { ProductBatchCard } from '../../../../components/global/cards/stock/BatchCard';
import { useGetCarriersQuery } from '../../../../newapi/carrier/carrierSlice';
import AllRelationCarriersCard from '../../../../components/global/cards/relation/carriers/AllRelationCarriersCard';
import ShDataGrid3 from '../../../../components/theme/datagrid3/ShDataGrid3';

const GridActions = (props) => {
    const theme = useTheme();
    return <></>
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const Carriers = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
            
        }
    },[]);

    
    const columns = [
        {field: "name", headerName: t("carrier") , flex:2, cellClassName: "carrier", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text semibold>{cellValues.value}</Text>
            )
        }},
        {field: "weight", headerName: `${t("weight_including_label")} (${t("gram")})`, flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{cellValues.value}</Text>
            )
        }},
        {field: "length", headerName: t("dimensions_lwh"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{`${cellValues.row.length} x ${cellValues.row.width} x ${cellValues.row.height}`}</Text>
            )
        }},
        {field: "safetyStock", headerName: t("safety_stock"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let pickingStock = cellValues.row.pickingStock ?? 0;
            let bulkStock = cellValues.row.bulkStock ?? 0;
            let totalStock = pickingStock + bulkStock;

            if (cellValues.row.safetyStock && cellValues.row.safetyStock > totalStock) {
                return (
                    <Text bold color={colors.red[400]}>{cellValues.row.safetyStock}</Text>
                );
            } else {
                return <Text>{cellValues.row.safetyStock}</Text>
            }
        }},
        {field: "pickingStock", headerName: t("stock"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let pickingStock = cellValues.row.pickingStock ?? 0;
            let bulkStock = cellValues.row.bulkStock ?? 0;
            let totalStock = pickingStock + bulkStock;

            return (
                <Text>{totalStock}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <AllRelationCarriersCard skeleton={cellValues.row.skeleton} {...cellValues.row} />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid3
                key={theme.palette.mode}
                gridKey="relations.products.shipmentmaterials"
                content={useGetCarriersQuery}
                // gridActions={<GridActions></GridActions>} 
                title={t('overview')}
                gridOptions={gridOptions}
                sortModel={{field: columns[1].field,type:"ASC"}}
                columns={columns}
            />
        </Box>
    );
};
export default Carriers;